import { useParams, useNavigate } from 'react-router-dom'
import { useServiceRequest } from '@/hooks/useRequests'
import useModalStore from '@/stores/ModalStore'
import ReviewModal from '@/modals/ReviewModal/ReviewModal'
import routes from '@/routes/routes'
import { useEffect } from 'react'

const ReviewDetail = () => {
    const { id } = useParams()
    const requestId = Number(id)
    const { data: request, isLoading } = useServiceRequest(requestId)
    const { setModalContent } = useModalStore()
    const navigate = useNavigate()

    useEffect(() => {
        if (request && !isLoading) {
            setModalContent(
                <ReviewModal
                    serviceRequestId={requestId}
                    serviceName={request.service_name || request.service?.name || 'Servicio'}
                    providerName={request.provider_email || 'Proveedor'}
                    handleClose={() => navigate(routes.requests)}
                />
            )
        }
    }, [request, isLoading, setModalContent, navigate, requestId])

    return (
        <div className="review-detail-page">
            <div className="review-detail-container">
                {isLoading && <div className="review-detail-message">Cargando...</div>}
            </div>
        </div>
    )
}

export default ReviewDetail


